import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { Fragment, useContext, useState } from "react";
import propTypes from "prop-types";
import { SessionContext } from "../../../../utility/useSession";
import { Trans, useTranslation } from "react-i18next";

const CarParkSwitcher: React.FunctionComponent<{
    show: boolean,
    onClose: () => void
}> = (props) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    let activeCarParkCode = "";
    if (session.current.site != null) {
        if (session.current.site.home != null) {
            activeCarParkCode = session.current.site.home.code;
        }
    }

    const [selectedCarPark, setSelectedCarPark] = useState<string>(activeCarParkCode);
    return <Fragment>
        <Dialog

            open={props.show}
            keepMounted

            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description">
            <DialogTitle id="alert-dialog-slide-title">
                <div style={{ textAlign: "center" }}>
                    {t("dash.labels.switchCarPark")}
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ width: 300, paddingBottom: 20, textAlign: "center" }}>      <Trans i18nKey="dash.labels.saveChanges" />
                </div>
                <div style={{ borderRadius: 5, border: "solid 1px lightgray" }}>
                    {session.current.site != null && (
                        session.current.site.carParks.map((carPark, indx) => {
                            if (session.current.site == null) {
                                return <Fragment key={indx}></Fragment>;
                            }
                            if (session.current.site.carParks == null) {
                                return <Fragment key={indx}></Fragment>;
                            }
                            const hasAccessToCarPark = session.current.site.user.carParkAccess.indexOf(`|${carPark.id}|`) != -1;

                            return <div key={indx} style={{
                                borderBottom: (indx + 1) == session.current.site.carParks.length ? "" : "solid 1px lightgray",
                                padding: 10,
                                cursor: hasAccessToCarPark == true ? "pointer" : "not-allowed",
                                backgroundColor: selectedCarPark == carPark.code ? "rgb(235, 48, 79)" : "",
                                color: selectedCarPark == carPark.code ? "white" : "black",
                                opacity: hasAccessToCarPark == true ? 1 : 0.5
                            }} onClick={() => {
                                if (hasAccessToCarPark == false) {
                                    return;
                                }
                                setSelectedCarPark(carPark.code);
                            }}>{carPark.name}</div>;
                        })
                    )}</div>
            </DialogContent>
            <DialogActions>
                <Button onClick={async () => {
                    props.onClose();
                }} color="primary">{t("general.cancel")}</Button>
                <Button disabled={selectedCarPark == ""} onClick={async () => {
                    props.onClose();
                    session.switchSite(selectedCarPark);
                }} color="primary">{t("general.ok")}</Button>
            </DialogActions>
        </Dialog>
    </Fragment>
}

CarParkSwitcher.propTypes = {
    show: propTypes.bool.isRequired,
    onClose: propTypes.func.isRequired
}
export default CarParkSwitcher;